import { dateTimeToView } from "helpers/date";
import React from "react";
import { PerformancePlanChangeLogModel } from "./types";

type PerformancePlanHistoryProps = {
    changes: PerformancePlanChangeLogModel[];
    resolveSubjectName: (change: PerformancePlanChangeLogModel) => string;
};

const changeLabels: Record<string, string> = {
    MileagePlan: "Пробег",
    OverallBidsPricePlan: "Валовая выручка",
    AutoCopyToNextMonth: "Перенос на следующие месяцы",
};

export default function PerformancePlanHistory({ changes, resolveSubjectName }: PerformancePlanHistoryProps) {
    if (!changes.length) {
        return <div className="card card-body py-4 text-center text-muted small">История изменений за выбранный месяц пуста.</div>;
    }

    return (
        <div className="card overflow-hidden">
            <div className="table-responsive">
                <table className="table table-sm mb-0 performance-plans__history-table">
                    <thead>
                        <tr>
                            <th style={{ width: "160px" }}>Дата и время</th>
                            <th style={{ width: "220px" }}>Пользователь</th>
                            <th style={{ width: "220px" }}>Объект</th>
                            <th>Изменения</th>
                        </tr>
                    </thead>
                    <tbody>
                        {changes.map((change, index) => (
                            <tr
                                key={`${change.changedAt}-${change.subjectType}-${change.subjectId ?? "organization"}-${index}`}
                            >
                                <td className="text-nowrap">{dateTimeToView(change.changedAt)}</td>
                                <td>{change.changedByName || "—"}</td>
                                <td>{resolveSubjectName(change)}</td>
                                <td>
                                    {Object.entries(change.changes).map(([field, value]) => (
                                        <div key={field} className="performance-plans__history-table__change-item">
                                            <span className="text-muted">{changeLabels[field] || field}:</span> {value}
                                        </div>
                                    ))}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
